import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/page/indexs'
import introduce from '@/components/page/introduce'
import settlementCertificate from '@/components/page/settlementCertificate'
import consultation from '@/components/page/consultation'
import aa from '@/components/page/aa'
import bb from '@/components/page/bb'
import about from '@/components/page/about'
import contact from '@/components/page/contact'
import repayment from '@/components/page/repayment'
import detail from '@/components/page/detail'
import paymentDetail from '@/components/page/paymentDetail'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: 'index',
      component: index
    },
    {
      path: '/index',
      name: 'index',
      component: index
    },
    {
      path: '/introduce',
      name: 'introduce',
      component: introduce
    },
    {
      path: '/consultation',
      name: 'consultation',
      component: consultation,
      children: [
        {
          path: 'aa',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'aa',
          component: aa
        },
        {
          path: 'bb',//以“/”开头的嵌套路径会被当作根路径，所以子路由上不用加“/”;在生成路由时，主路由上的path会被自动添加到子路由之前，所以子路由上的path不用在重新声明主路由上的path了。
          name: 'bb',
          component: bb
        }
      ]
    },{
      path: '/about',
      name: 'about',
      component: about
    },{
      path: '/contact',
      name: 'contact',
      component: contact
    },{
      path: '/repayment',
      name: 'repayment',
      component: repayment
    },{
      path: '/detail',
      name: 'detail',
      component: detail
    },
    {
      path: '/paymentDetail',
      name: 'paymentDetail',
      component: paymentDetail,
    },
    {
      path: '/settlementCertificate',
      name: 'settlementCertificate',
      component: settlementCertificate,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js